import { colorPalette } from '@next-common/mui';
export const circleContainer = () => ({
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    backgroundColor: '#009FFF',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
export const circleContent = () => ({
    color: 'white',
    fontSize: 16,
});
export const listContainer = () => ({
    fontFamily: 'RakutenSansUi, serif',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
    margin: '1.6rem 0',
});
export const title = () => ({
    fontFamily: 'RakutenSansUi, serif',
    fontStyle: 'normal',
    color: colorPalette.gray600,
    fontWeight: 600,
    lineHeight: 'normal',
});
export const headTitle = () => ({
    color: colorPalette.gray1000,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    fontSize: '2rem',
});
export const legalText = () => ({
    fontFamily: 'RakutenSansUi, serif',
    color: colorPalette.gray600,
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    borderTop: `1px solid ${colorPalette.gray300}`,
    padding: '1.6rem 0',
    '& div ': {
        margin: '2px',
    },
});
export const linkText = () => ({
    color: colorPalette.gray600,
    fontWeight: 400,
    fontSize: '12px',
    '&:hover': {
        textDecoration: 'underline',
    },
});
export const floa = () => ({ alignSelf: 'center' });
export const container = () => ({
    display: 'flex',
    justifyContent: 'center',
    margin: '1.6rem',
});
